"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartShippingOptionToJSON = exports.CartShippingOptionFromJSONTyped = exports.CartShippingOptionFromJSON = exports.instanceOfCartShippingOption = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CartShippingOption interface.
 */
function instanceOfCartShippingOption(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCartShippingOption = instanceOfCartShippingOption;
function CartShippingOptionFromJSON(json) {
    return CartShippingOptionFromJSONTyped(json, false);
}
exports.CartShippingOptionFromJSON = CartShippingOptionFromJSON;
function CartShippingOptionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'price': !(0, runtime_1.exists)(json, 'price') ? undefined : json['price'],
        'freeShippingThreshold': !(0, runtime_1.exists)(json, 'freeShippingThreshold') ? undefined : json['freeShippingThreshold'],
    };
}
exports.CartShippingOptionFromJSONTyped = CartShippingOptionFromJSONTyped;
function CartShippingOptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'price': value.price,
        'freeShippingThreshold': value.freeShippingThreshold,
    };
}
exports.CartShippingOptionToJSON = CartShippingOptionToJSON;
